module.exports = __webpack_public_path__ + "static/Hero3-2a6a5c005b85bc440d2ddd34bd75047e.png";